import cjyygl from './cjyygl'
import zbyczz from './zbyczz';
import zhongbiaogg from './zhongbiaogg';
import zbjgtzs from './zbjg-tzs';
import zbhxr from './zbhxr'
import zbhxrgs from './zbhxr-gs'
import servicevaluation from './servicevaluation';
import evaluate from './evaluate';
import evaluateaccount from './evaluateaccount';
import frameAgreement from './frame-agreement';
export default {
    path: 'dingbiao',
    component: () => import(/*webpackChunkName: 'bidding-dingbiao'*/ '@layout/empty'),
    children: [
        zbyczz,
        zhongbiaogg,
        zbjgtzs,
        zbhxr,
        cjyygl,
        zbhxrgs,
        servicevaluation,
        evaluate,
        evaluateaccount,
        frameAgreement
    ]
}